import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { Route, Switch } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'

import CustomerVoicesIndexPage from '../containers/CustomerVoices'

import appActions from '../redux/app/actions'

const { changeCurrent } = appActions

const CustomerVoicesPage = ({ location, match }) => {
  const dispatch = useDispatch()
  const current = useSelector(state => state.getIn(['App', 'current'])).toJS()
  const { pathname } = location

  useEffect(() => {
    if (current[0] !== 'customer_voices') {
      dispatch(changeCurrent(['customer_voices']))
    }
  }, [pathname])

  const path = match.url

  return (
    <Switch>
      <Route path={`${path}/`} component={CustomerVoicesIndexPage} exact />
    </Switch>
  )
}

CustomerVoicesPage.propTypes = {
  location: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired
}

export default CustomerVoicesPage
